/**
 * Copy and analytics values for clinical-document thumbs-up / thumbs-down feedback.
 *
 * @module documentFeedback/constants
 */

/** Dialog title shown when the reviewer rejects the document. */
export const DOCUMENT_FEEDBACK_MODAL_TITLE = "Share feedback";

/** Prompt above the thumbs-down comment field. */
export const DOCUMENT_FEEDBACK_MODAL_PROMPT =
  "Tell us what was wrong with this document.";

/** Placeholder for the thumbs-down comment textarea. */
export const DOCUMENT_FEEDBACK_MODAL_PLACEHOLDER =
  "Enter your feedback here...";

/** Primary action label on the thumbs-down dialog. */
export const DOCUMENT_FEEDBACK_MODAL_SAVE = "Submit";

/** Cancel action label on the thumbs-down dialog. */
export const DOCUMENT_FEEDBACK_MODAL_CANCEL = "Cancel";

/** Toast shown after thumbs-down feedback is submitted. */
export const DOCUMENT_FEEDBACK_SUCCESS_TOAST = "Thanks for your feedback";

/** Amplitude / BigQuery value for a thumbs-up (approve) action. */
export const DOCUMENT_FEEDBACK_APPROVED = "thumbs_up";

/** Amplitude / BigQuery value for a thumbs-down (reject) action. */
export const DOCUMENT_FEEDBACK_REJECTED = "thumbs_down";
